import * as React from 'react';

export function Logo({ width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 4995 4162"
    >
      <path d="M2170 670c4,2 4,2 -1,0 -2,1 -4,2 -6,1 -2,-1 -3,-2 -3,-4 -11,-3 -31,-10 -61,-24 -68,-31 -180,-76 -295,-100 6,14 9,29 9,45 0,64 -52,116 -116,116 -64,0 -116,-52 -116,-116 0,-20 5,-39 14,-56 -43,8 -83,23 -115,49 -5,5 -11,10 -16,15 -3,2 -6,2 -9,0 -2,-3 -2,-7 0,-9 6,-6 11,-11 17,-16 4,-4 9,-8 13,-12 81,-76 172,-163 507,11 10,5 34,17 60,30 55,27 122,61 119,68 0,0 -1,1 -1,2zm-20 -14c3,2 6,3 9,5 -2,-1 -5,-3 -9,-5zm1093 1177c5,-203 64,-325 42,-543 -21,-218 -95,-787 -755,-1160 -659,-372 -1202,149 -1319,362 -117,213 -144,383 -223,490 -80,106 -282,335 -511,452 -229,117 -425,244 -457,303 -32,58 -32,127 53,122 85,-5 473,-74 718,-213 245,-138 548,-207 548,-207 86,158 325,-108 601,154 218,208 345,436 143,718 -372,519 -727,809 -590,1516 313,254 981,322 1378,335 159,6 308,-1766 1707,-2170 1206,-349 -531,102 -1120,314 -133,48 -334,161 -451,238 13,-16 187,-161 258,-219 -49,-197 -15,-302 -22,-492z" />
    </svg>
  );
}
